
import React, { useState, useEffect } from 'react';
import './FatcaCRSDeclaration.modules.css';
import { useTranslation } from 'react-i18next';


const FatcaCRSDeclaration8 = (props) => {
    const { t } = useTranslation();

    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [BtnDisabled, setSelectedBtnDisabled] = useState(true);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setSelectedBtnDisabled(false);
            setSelectedCheckboxes([...selectedCheckboxes, value]);
        } else {
            setSelectedBtnDisabled(true);
            setSelectedCheckboxes(selectedCheckboxes.filter((item) => item !== value));
        }
    };

    useEffect(() => {
        
        if (props.IsCallAPI){
            props.setIsCallAPI(false);
            props.handleNext();
        }
   
    }, [props.IsCallAPI]);





    return (
        <div className="FatcaCRSDeclaration">
            <div className="form-container">
                <form className="dropdown-form">
                    <div className="form-group">
                        <h5 >{ t("Declaration")}</h5>


                        <div className="seekbar-wrapper" >
                            <div className='Declaration-container'>
                                <label>
                                    <input
                                        type="checkbox"
                                        value="Option 2"
                                        onChange={handleCheckboxChange}
                                    />
                                 {t("confirm_information_true")}
                                </label>
                                {/* <button disabled={BtnDisabled} onClick={(e) => e.preventDefault}> OK</button> */}
                            </div>


                        </div>

                    </div>




                    {/* <button type="submit" className="submit-button">Submit</button> */}
                </form>
            </div>
        </div>
    );
};


export default FatcaCRSDeclaration8;





